import { render, staticRenderFns } from "./jointPreferencesDetail.vue?vue&type=template&id=dfe2c544&scoped=true&"
import script from "./jointPreferencesDetail.vue?vue&type=script&lang=js&"
export * from "./jointPreferencesDetail.vue?vue&type=script&lang=js&"
import style0 from "./jointPreferencesDetail.vue?vue&type=style&index=0&id=dfe2c544&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe2c544",
  null
  
)

export default component.exports